// @ts-nocheck
/**
 * A custom element that displays product media.
 */
class ProductMedia extends HTMLElement {
  constructor() {
    super();

    this.scrollbar = this.querySelector('.scrollbar-wrapper');
    this.scrollbarThumb = this.querySelector('.scrollbar-thumb');
  }

  connectedCallback() {
    if (!this.scrollbar || !this.scrollbarThumb) return;

    this.addEventListener('scroll', () => {
      const scrollableWidth = this.scrollWidth - this.clientWidth;
      const progress = this.scrollLeft / scrollableWidth;

      const styles = getComputedStyle(this.scrollbar);
      const paddingLeft = parseFloat(styles.paddingLeft);
      const paddingRight = parseFloat(styles.paddingRight);

      const trackWidth = this.scrollbar.clientWidth - paddingLeft - paddingRight;
      const thumbWidth = this.scrollbarThumb.clientWidth;

      const maxMove = trackWidth - thumbWidth;

      this.scrollbarThumb.style.left = `${progress * maxMove}px`;
    });
  }
}

if (!customElements.get('product-media')) {
  customElements.define('product-media', ProductMedia);
}